import {AxiosError} from 'axios';

import {
    Completable,
    ConfirmationDetailDTO,
    DisclaimerDTO,
    failed,
    InfoBlockDTO,
    KashableResponseDTO,
    LoanApplicationDTO,
    LoanApplicationResultDTO,
    LoanApplicationTermResultDTO,
    LoanSummaryDTO,
    UnderwritingContext,
} from 'kashable-mobile-common';

import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

/* eslint-disable */
const handleApplyError: (e: AxiosError<any>) => Completable<ConfirmationDetailDTO[] | any> = (error) => {
    /* eslint-enable */
    const {response} = error;
    if (response) {
        const {data, headers, status} = response;
        if (typeof data !== 'string') {
            return {
                code: status,
                headers,
                value: data.data,
                message: 'Reverification required',
                pending: false,
            };
        } else {
            return {
                code: status,
                headers,
                message: data,
                error: data,
                pending: false,
            };
        }
    }

    return failed({
        message: 'There was an error',
        code: 400,
        headers: {},
    });
};

const load: () => Promise<Completable<boolean | ConfirmationDetailDTO[]>> = () => {
    return axios
        .get<KashableResponseDTO<boolean | ConfirmationDetailDTO[]>>('/secured/user/loan/apply')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch(handleApplyError);
};

const apply: (a: LoanApplicationDTO) => Promise<Completable<LoanApplicationResultDTO | ConfirmationDetailDTO[]>> = (app) => {
    return axios
        .post<KashableResponseDTO<LoanApplicationResultDTO>>('/secured/user/loan/apply', app)
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch(handleApplyError);
};

const signLoan: () => Promise<Completable<number>> = () => {
    return axios
        .put<KashableResponseDTO<number>>('/secured/user/loan/apply')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch(handleApplyError);
};

const getLoanAmounts: (t: number, u: UnderwritingContext) => Promise<Completable<LoanApplicationTermResultDTO>> = (
    term: number,
    uec: UnderwritingContext,
) => {
    return axios
        .get<KashableResponseDTO<LoanApplicationTermResultDTO>>(`/secured/user/loan/apply/${term}`, {params: {uec}})
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};


// this can return a LoanSummaryDTO but we only care about confirmation cards
const selectAmount: (t: number, k:number,  u: UnderwritingContext) => Promise<Completable<ConfirmationDetailDTO[]>> = (
    term: number,
    kash: number,
    uec: UnderwritingContext,
) => {
    return axios
        .put<KashableResponseDTO<ConfirmationDetailDTO[]>>(`/secured/user/loan/apply/${term}/${kash}`, '', {params: {uec}})
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch(handleApplyError);
};

const getLoanDetails: (
    t: number,
    k: number,
    u: UnderwritingContext,
) => Promise<Completable<LoanSummaryDTO>> = (term: number, kash: number, uec: UnderwritingContext) => {
    return axios
        .get<KashableResponseDTO<LoanSummaryDTO>>(`/secured/user/loan/apply/${term}/${kash}`, {params: {uec}})
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getDisclaimers: () => Promise<Completable<Array<DisclaimerDTO>>> = () => {
    return axios
        .get<KashableResponseDTO<Array<DisclaimerDTO>>>('/secured/user/disclaimers')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const continueApp: (
    u: UnderwritingContext,
) => Promise<Completable<LoanApplicationResultDTO | Array<ConfirmationDetailDTO>>> = (uec: UnderwritingContext) => {
    return axios
        .post<KashableResponseDTO<LoanApplicationResultDTO>>('/secured/user/loan/apply', {uec})
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch(handleApplyError);
};

const fetchGotItCards: () => Promise<Completable<Array<InfoBlockDTO>>> = () => {
    return axios
        .get<KashableResponseDTO<Array<InfoBlockDTO>>>('/secured/user/info-block')
        .then((res) => mapSucceeded(res, (d) => d.data || []))
        .catch((error: AxiosError<string>) => errored(error));
};

const getApplication: () => Promise<Completable<LoanSummaryDTO>> = () => {
    return axios
        .get<KashableResponseDTO<LoanSummaryDTO>>('/secured/user/application')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {
    load,
    apply,
    signLoan,
    getLoanAmounts,
    selectAmount,
    getDisclaimers,
    continueApp,
    fetchGotItCards,
    getApplication,
    getLoanDetails,
};
